import { ServiceUsingCountLimiter } from "@/services/license/license-limiters/base-limiters/service-using-count-limiter";
import { LicenseName } from "@/data/license.data";
export const trialConvertsCount = 3;

export class ConvertUsingCountLimiter extends ServiceUsingCountLimiter {
  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return trialConvertsCount;
      case "Basic":
        return 50;
      case "Starter":
        return 500;
      case "Creator":
        return 1000;
      default:
        return Infinity;
    }
  }

  getUniqueLimit(userId: string): Promise<number | null> {
    return Promise.resolve(null);
  }
}
